//export const API_ENDPOINT = "https://teaparty-website-server.onrender.com";

export const API_ENDPOINT = "http://localhost:5000";
